import themeResources from './_PROJECT_NAME_/resources.json';

export const theme = `${process.env.PROJECT_NAME}`;

export const projectName = `${process.env.PROJECT_NAME}`;

export const getCurrentResource = () => themeResources;

export const getCurrentImagesPath = () => `${theme}/images`;
